import React, { useEffect, useState } from "react";
import CatComplete from '../../../assets/images/cat_complete.svg';
import CatCompleteNoDocLoan from '../../../assets/images/no-doc-loan/cat_completed.png';

function StepFormComplete({ page }) {

    const [countDown, setCountDown] = useState(15);

    useEffect(() => {
        window.scrollTo(0, 0);
        let count = 15;
        const time = setInterval(() => {
            count -= 1;
            setCountDown(count);
            if (count <= 0) {
                clearInterval(time);
                goToHome();
            }
        }, 1000);
    }, []);

    const goToHome = () => {
        localStorage.removeItem('access_token');
        return window.location.href = process.env.REACT_APP_HOME_URL
    }

    return (
        <div className="bg-white lg:px-10">
            {
                page === 'no-doc-loan' ? <div className="mx-auto flex max-w-[760px] flex-col items-center lg:flex-row lg:items-start lg:justify-center lg:gap-10">
                    <div className="flex items-start justify-center lg:w-[250px] lg:shrink-0">
                        <img className="mb-12 mx-auto max-w-full h-auto object-contain shrink-0 lg:w-[250px]" src={CatCompleteNoDocLoan} alt="" />
                    </div>
                    <div className="flex max-w-[420px] flex-col text-gray1 text-justify">
                        <p>感謝閣下申請，申請編號會透過手機短訊（SMS）發送到閣下所登記之手提電話號碼，方便日後查閱申請進度。接收SMS可能需時數分鐘，請耐心等候。</p>
                        <p className="my-4">我們的貸款專員會盡快處理閣下的申請及與閣下聯絡。如有任何疑問，歡迎於辦公時間內致電 2366 8859。</p>
                        <div className="flex justify-center mb-4 mt-9">
                            <button onClick={goToHome} className={`rounded-full text-white text-xl px-14 py-3 bg-primary button-complete`}>
                                返回主頁 <span>( {countDown} )</span>
                            </button>
                        </div>
                    </div>
                </div> :
                    <>
                        <div className="mx-auto flex max-w-[760px] justify-center items-center my-5">
                            <img className="w-1/2 h-auto object-contain lg:w-auto" src={CatComplete} alt="" />
                        </div>
                        <div className="mx-auto flex max-w-[520px] justify-start flex-col text-gray1 text-justify">
                            <p>感謝閣下申請，申請編號會透過手機短訊（SMS）發送到閣下所登記之手提電話號碼，方便日後查閱申請進度。接收SMS可能需時數分鐘，請耐心等候。</p>
                            <p className="my-7">我們的貸款專員會盡快處理閣下的申請及與閣下聯絡。如有任何疑問，歡迎於辦公時間內致電 2366 8859。</p>
                        </div>
                        <div className="flex justify-center mb-4 mt-9">
                            <button onClick={goToHome} className={`rounded-full text-white text-xl px-14 py-3 bg-primary button-complete`}>
                                返回主頁 <span>( {countDown} )</span>
                            </button>
                        </div>
                    </>
            }

        </div>
    );
}

export default StepFormComplete;
